<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/j3MhlY/images/9780312331931.jpg?1712288212453" alt="This image is the cover for the book Mercy Seller"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mercy Seller
      </h1>
      <p class="bookDescription body article font2">
        <p>In the fifteenth century, with religious intolerance spreading like wildfire across Europe, English-born Anna Bookman and her grandfather, Finn, earn a living in Prague by illuminating precious books, including forbidden translations of the Bible. Finn subscribes to the heresy that people ought to be able to read the Word of God for themselves, without having to pay a priest for the privilege, but holding that belief is becoming more and more hazardous. When the authorities start burning books and slaughtering heretics---including the man Anna was to marry---Finn urges her to seek sanctuary in England, but her passage abroad will be anything but easy. <br/>In London, Friar Gabriel dutifully obeys church doctrine by granting pardons . . . for a small fee. But then he is sent undercover on a spying mission to France, where Anna has set up a temporary stall as a bookseller. Anna has no way of knowing that the wealthy young merchant frequenting her stall is actually a priest---just as Gabriel does not know he has met the woman who will cause him to doubt his vows.<br/>As Anna continues her journey to England, where the movement to stamp out heresy is growing ever fiercer, Brenda Rickman Vantrease brings us a richly imagined and immensely rewarding novel of love, faith, and dangerous secrets.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Brenda Rickman Vantrease
      </h2>
      
      <p class="authorDescription body article"><P>Brenda Rickman Vantrease is a former English teacher and librarian who has traveled extensively in Europe and lives in Nashville, Tennessee. Her first novel, <I>The Illuminator,</I> was translated into fifteen languages and chosen as a Book Sense 2006--2007 Reading Group Pick.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      ST. MARTIN’S PRESS
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?741cde5f